module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright caption"
  }, [_vm._v(" Copyright " + _vm._s(_vm.year) + " Matthieu Lavanchy"), (_vm.credits) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCredits),
      expression: "!showCredits"
    }],
    on: {
      "click": function($event) {
        _vm.showCredits = !_vm.showCredits
      }
    }
  }, [_vm._v(". Site Credits")]) : _vm._e(), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCredits),
      expression: "showCredits"
    }]
  }, [_vm._v(" Site designed by "), _c('a', {
    attrs: {
      "href": "http://spencerfenton.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("Spencer Fenton")]), _vm._v(" & developed by "), _c('a', {
    attrs: {
      "href": "http://everettwilliams.info",
      "target": "_blank"
    }
  }, [_vm._v("Everett Williams")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b727cd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 154
// module chunks = 1